import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import "./BrandService.css";

const FridgeService = () => {
  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <title>Refrigerator Service & Repair Center in Bangalore</title>
        <meta
          name="description"
          content="Trusted fridge service in Bangalore. Fast refrigerator repair, gas filling, cooling issue fixing, and maintenance services."
        />
        <meta
          name="keywords"
          content="fridge service Bangalore, refrigerator repair Bangalore, fridge repair near me, cooling issue repair,fridge repair in bangalore,fridge repair service Bangalore"
        />
        <meta property="og:title" content="Refrigerator Service & Repair Center in Bangalore" />
        <meta
          property="og:description"
          content="Professional refrigerator repair services in Bangalore with trained technicians and quick doorstep support for all brands."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/fridge-service-bangalore" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Refrigerator Service & Repair Center in Bangalore" />
        <meta
          name="twitter:description"
          content="Professional refrigerator repair services in Bangalore with trained technicians and quick doorstep support for all brands."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/fridge-service-bangalore" />
      </Helmet>

      {/* ✅ BANNER */}
      <div className="brand-service-banner">
        <InnerBanner
          title="Refrigerator Service in Bangalore"
          bgImage={serviceBg}
        />
      </div>

      <div className="brand-service-page service-page">

        {/* INTRO */}
        <p style={{ textAlign: 'justify' }}>
        Looking for trusted <span style={{ fontWeight: 'bold' }}>refrigerator service center in Bangalore</span>? Customer Supports 24x7 provides professional doorstep repair services without the hassle of visiting a physical service center. Our goal is to bring fast, reliable, and affordable solutions directly to your home.
        </p>

        <p style={{ textAlign: 'justify' }}>
         We understand how important your refrigerator is to keep your food fresh and healthy. That's why our technicians are trained to handle all brands and models, including single door, double door, and multi-door refrigerators.
        </p>

        {/* SERVICE SOLUTIONS */}
        <div className="card">
          <h2>Our Service Center Solutions Include</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>Complete inspection and fault diagnosis</li>
            <li>Repair of cooling and freezing systems</li>
            <li>Replacement of damaged parts with genuine spares</li>
            <li>Regular maintenance and servicing</li>
            <li>Installation services for new refrigerators</li>
            <li>Gas refilling and leak detection</li>
          </ul>
        </div>

        {/* COMMON ISSUES */}
        <div className="card">
          <h2>Common Issues We Fix</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>Refrigerator not cooling properly</li>
            <li>Excessive frost formation</li>
            <li>Water leakage and drainage problems</li>
            <li>Noise and vibration issues</li>
            <li>Compressor and motor failures</li>
            <li>Thermostat and sensor malfunctions</li>
            <li>Door seal and latch problems</li>
          </ul>
        </div>

        {/* SINGLE DOOR SECTION */}
        <div className="card">
          <h2>Single Door Refrigerator Service</h2>

          <p style={{ textAlign: 'justify' }}>
            Looking for reliable <span style={{ fontWeight: 'bold' }}>single door fridge service in Bangalore</span>?
            We provide expert repair and maintenance solutions for all single door
            models with advanced diagnostics and quick service.
          </p>

          <p style={{ textAlign: 'justify' }}>
            Single door refrigerators are economical and space-saving. When issues arise, our trained technicians ensure precise
            repairs and long-lasting performance.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Compressor repair and replacement</li>
            <li>Cooling system maintenance</li>
            <li>Gas refilling</li>
            <li>Thermostat and control panel repairs</li>
            <li>Door seal replacement</li>
          </ul>

          <h3>Common Single Door Issues</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Not cooling</li>
            <li>Excessive frost formation</li>
            <li>Strange noises</li>
            <li>Door not closing properly</li>
          </ul>
        </div>

        {/* DOUBLE DOOR SECTION */}
        <div className="card">
          <h2>Double Door Refrigerator Service</h2>

          <p style={{ textAlign: 'justify' }}>
            Our technicians specialize in <span style={{ fontWeight: 'bold' }}>double door fridge repair services</span> for all major brands. We provide efficient and cost-effective solutions for both fridge and freezer compartments.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Dual cooling system maintenance</li>
            <li>Independent freezer repairs</li>
            <li>Ice maker troubleshooting</li>
            <li>Water dispenser repairs</li>
            <li>Inverter technology repairs</li>
            <li>Smart technology diagnostics</li>
          </ul>

          <h3>Common Double Door Issues</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Fridge not cooling while freezer works</li>
            <li>Ice maker not functioning</li>
            <li>Water dispenser issues</li>
            <li>Excessive ice buildup in freezer</li>
            <li>Both compartments not cooling equally</li>
          </ul>
        </div>

        {/* MULTI-DOOR SECTION */}
        <div className="card">
          <h2>Multi-Door & French Door Service</h2>

          <p style={{ textAlign: 'justify' }}>
            For advanced <span style={{ fontWeight: 'bold' }}>multi-door refrigerator repairs</span>, our expert team handles the latest smart refrigerator models with specialized knowledge.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Advanced cooling zone repairs</li>
            <li>Smart feature diagnostics</li>
            <li>Wi-Fi connectivity issues</li>
            <li>Door dispenser repairs</li>
            <li>Advanced compressor services</li>
          </ul>
        </div>

        {/* WHY CHOOSE */}
        <div className="card">
          <h2>Why Choose Our Service?</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>✔ Experienced technicians for all brands</li>
            <li>✔ Same-day service availability</li>
            <li>✔ Genuine spare parts guarantee</li>
            <li>✔ Affordable service charges</li>
            <li>✔ Warranty on parts and labor</li>
            <li>✔ Emergency service available</li>
          </ul>
        </div>

        {/* CTA */}
        <div className="cta-box">
          <h3>Book Service Today</h3>
          <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
            Skip long queues at service centers—call now and get expert service
            at your doorstep anywhere in Bangalore.
          </p>

          <a href="tel:8050731754">
            <button className="call-btn">📞 Call Now</button>
          </a>
        </div>

      </div>
    </>
  );
};

export default FridgeService;

